import { render, staticRenderFns } from "./HospedesAvulsosList.vue?vue&type=template&id=ff25c24a&"
import script from "./HospedesAvulsosList.vue?vue&type=script&lang=js&"
export * from "./HospedesAvulsosList.vue?vue&type=script&lang=js&"
import style0 from "./HospedesAvulsosList.vue?vue&type=style&index=0&id=ff25c24a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports